import { create } from 'zustand';
import { reportsService, type ReportListParams } from '../services/reportsService';

interface ReportsState {
  errorCount: number;
  loading: boolean;
  getListReports: (params?: ReportListParams) => Promise<any>;
  getErrorCount: () => Promise<number>;
  processComboWithError: (combo_ids: string[]) => Promise<any>;
}

export const useReportsStore = create<ReportsState>((set) => ({
  errorCount: 0,
  loading: false,

  getListReports: async (params?: ReportListParams) => {
    try {
      const response = await reportsService.getReportsList(params);
      if (response.count !== undefined) {
        set({ errorCount: response.count });
      }
      return response;
    } catch (error) {
      console.error('Error fetching Reports:', error);
      throw error;
    }
  },

  getErrorCount: async () => {
    try {
      set({ loading: true });
      const response = await reportsService.getReportsList({ page: 1, page_size: 1 });
      set({ errorCount: response.count, loading: false });
      return response.count;
    } catch (error) {
      console.error('Error fetching error count:', error);
      set({ loading: false });
      return 0;
    }
  },

  processComboWithError: async (combo_ids: string[]) => {
    set({ loading: true });
    try {
      const response = await reportsService.processComboWithError(combo_ids);
      set({ loading: false });
      return response;
    } catch (error) {
      set({ loading: false });
      console.error('Error processing combo with error:', error);
      throw error;
    }
  }
}));
